import { defineTokens, defineSemanticTokens } from "@pandacss/dev";

/**
 * Spacing tokens
 * Define consistent spacing values for margins, padding, and gaps
 *
 * @example
 * ```tsx
 * <Box padding="md" gap="lg" />
 * ```
 */
export const spacing = defineTokens.spacing({
	/** Inverse large: -0.75rem */
	ilg: { value: "-0.75rem" },
	/** Inverse medium: -0.5rem */
	imd: { value: "-0.5rem" },
	/** Inverse small: -0.375rem */
	ism: { value: "-0.375rem" },
	/** Inverse extra small: -0.25rem */
	ixs: { value: "-0.25rem" },
	/** No spacing: 0rem */
	none: { value: "0rem" },
	/** Border spacing: 0.2rem */
	border: { DEFAULT: { value: ".2rem" } },
	/** Extra small: 0.05rem base, with x/y variants */
	xs: { DEFAULT: { value: "0.05rem" }, x: { value: "6px" }, y: { value: ".05rem" } },
	/** Small: 0.375rem base, with x/y variants */
	sm: { DEFAULT: { value: "0.375rem" }, x: { value: "8px" }, y: { value: ".375rem" } },
	/** Medium: 0.5rem base, with x/y variants */
	md: {
		DEFAULT: { value: "0.5rem" },
		x: { value: "15px" },
		y: { value: ".5rem" },
	},
	/** Large: 1rem base, with x/y variants */
	lg: { DEFAULT: { value: "1rem" }, x: { value: "20px" }, y: { value: "1rem" } },
});

/**
 * Semantic spacing tokens
 * Contextual spacing values mapped to specific use cases
 */
export const semanticSpacing = defineSemanticTokens.spacing({
	layout: {
		full: { value: "100%" },
	},
	nav: {
		width: { value: "12rem" },
		minWidth: { value: "3rem" },
	},
	border: {
		thin: { value: "1px" },
		thick: { value: "2px" },
	},
});
